let language = {
    BANK_TRANSFER_INTRO_WEBSITE_ACCOUNT_NO:"Account Number:",
    BANK_TRANSFER_INTRO_WEBSITE_BENEFICIARY:"Beneficiary Name:",
    BANK_TRANSFER_INTRO_WEBSITE_BANK:"Bank Name:",
    BANK_TRANSFER_INTRO_WEBSITE_BANK_CODE:"Bank Code:",
    BANK_TRANSFER_INTRO_WEBSITE_SWIFT_CODE:"Swift Code:",
    BANK_TRANSFER_INTRO_WEBSITE_BANK_ADDRESS:"Bank Address:",
    
};

export { language }